(() => {
  function isTechSheetHeading(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;

    const tag = node.tagName.toUpperCase();

    if (/^H[2-6]$/.test(tag)) return true;

    if (tag === 'P') {
      const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      const firstChild = node.firstElementChild;

      const looksLikeSectionTitle =
        text.length > 0 &&
        text.length < 80 &&
        (
          (firstChild && /^(STRONG|B)$/.test(firstChild.tagName)) ||
          node.classList.contains('heading')
        );

      if (looksLikeSectionTitle) return true;
    }

    return false;
  }

  function initTechnicalSheetGrid(scope = document) {
    const fichaContents = scope.querySelectorAll(
      '.tab-content#ficha .rte.text--pull, .tab-content#ficha .rte'
    );

    fichaContents.forEach((container) => {
      if (!container || container.dataset.techSheetReady === 'true') return;

      const children = Array.from(container.childNodes).filter((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          return node.textContent.trim() !== '';
        }

        if (node.nodeType !== Node.ELEMENT_NODE) return false;

        if (node.tagName === 'P' && node.textContent.trim() === '') return false;

        return true;
      });

      if (!children.length) return;

      const grid = document.createElement('div');
      grid.className = 'product-tech-sheet-grid';

      let currentBlock = null;

      children.forEach((node) => {
        const isHeading = isTechSheetHeading(node);

        if (isHeading) {
          currentBlock = document.createElement('div');
          currentBlock.className = 'product-tech-sheet-block';
          grid.appendChild(currentBlock);
          currentBlock.appendChild(node);
          return;
        }

        if (!currentBlock) {
          currentBlock = document.createElement('div');
          currentBlock.className = 'product-tech-sheet-block';
          grid.appendChild(currentBlock);
        }

        currentBlock.appendChild(node);
      });

      container.innerHTML = '';
      container.appendChild(grid);
      container.dataset.techSheetReady = 'true';
    });
  }

  function runTechSheetInit() {
    initTechnicalSheetGrid(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runTechSheetInit);
  } else {
    runTechSheetInit();
  }

  document.addEventListener('shopify:section:load', runTechSheetInit);
})();